import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Table from '../elements-table/table';
import AttendeePricingForm from './forms/AttendeePricingForm';
import { updateShowVariableAttendeeForm } from '../app-main/actions/calendarPricing';
import AttendeeTable from './AttendeeTable';
import Button from './../elements-buttons/Button';
import { FormattedMessage } from 'react-intl';

const AttendeeRate = ({
  listing,
  dispatch,
  showAttendeePricingForm
}) => {
  const numberGuests = get(listing, 'number_guests');
  const defaultTier = { min: 1, max: numberGuests, value: 0 };
  const attendeeTiers = get(listing, 'attendee_pricing.tiers', [defaultTier]);
  const currency = get(listing, 'prices.0.currency', '');
  const handleAddVariableClick = () => dispatch(updateShowVariableAttendeeForm(true));
  const handleCancel = (e) => {
    e.preventDefault();
    dispatch(updateShowVariableAttendeeForm(false));
  };

  return (
    <div>
      <h4><FormattedMessage id="hosting.attending_rate.heading" defaultMessage="Attendee pricing" /></h4>
      <p className="text-small text-gray-dark">
        <FormattedMessage id="hosting.attending_rate.additional_charge_text" defaultMessage="Add an additional charge depending on the number of attendees." />
      </p>
      <div className="clearfix" />
      {
        attendeeTiers.length && !showAttendeePricingForm ?
          <div className="row margin-lg-top margin-md-bottom">
            <div className="col-xs-12">
              <Table
                tableHeaders={
                  [
                    { label: <FormattedMessage id="hosting.attending_rate.attendees_tabel_label" defaultMessage="Attendees" />, classname: 'flex-basis-50' },
                    { label: <FormattedMessage id="hosting.attending_rate.additional_charge_tabel_label" defaultMessage="Additional charge/ hr" />, classname: 'flex-basis-50 text-right' }
                  ]
                }
                tableBodyClass="calendar-price-table-body"
                tableBody={
                  <AttendeeTable
                    attendeeTiers={attendeeTiers}
                    currency={currency}
                  />
                }
              />
            </div>
          </div> : null
      }
      <div className="row margin-lg-top margin-md-bottom">
        <div className="col-xs-12">
          {
            showAttendeePricingForm ?
              <AttendeePricingForm
                initialValues={{
                  number_guests: numberGuests,
                  tiers: attendeeTiers
                }}
                handleCancel={handleCancel}
                currency={currency}
              /> :
              <Button
                category="default"
                onClick={handleAddVariableClick}
                type="button"
              >
                <FormattedMessage id="hosting.attending_rate.button_text_edit" defaultMessage="Edit" />
              </Button>
          }
        </div>
      </div>
      <div className="clearfix" />
      <hr />
    </div>
  );
};

AttendeeRate.propTypes = {
  listing: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
  showAttendeePricingForm: PropTypes.bool
};

export default AttendeeRate;
